import React from 'react';
type BadgeVariant = 'amber' | 'navy' | 'parchment' | 'green' | 'red';
interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
}
const variantStyles: Record<BadgeVariant, string> = {
  amber: 'bg-amber-light text-warm-brown border border-amber/30',
  navy: 'bg-navy text-amber border border-navy-light',
  parchment: 'bg-parchment text-ink-muted border border-parchment',
  green: 'bg-green-100 text-green-700 border border-green-200',
  red: 'bg-red-100 text-red-700 border border-red-200'
};
export function Badge({
  children,
  variant = 'amber',
  className = ''
}: BadgeProps) {
  return <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-sans font-medium tracking-wide uppercase ${variantStyles[variant]} ${className}`} data-id="element-77">
      {children}
    </span>;
}